import { noveltiesNameSpace, TypeNoveltiesReducer } from "./types";

const getInitial = (
  state: Record<noveltiesNameSpace, TypeNoveltiesReducer>
): TypeNoveltiesReducer => state.novelties;

export const getNovelties = (
  state: Record<noveltiesNameSpace, TypeNoveltiesReducer>
) => getInitial(state);
